import { prepareFormToSubmit } from 'UI/utils/forms';

import { buildResolvedEmailBody } from '../../forms/EmailDetails/EmailDetails.utils';

import {
  FORM_FIELDS_MAP,
  SENDOVER_CREATION_EMAIL_FIELDS_MAP,
  SENDOVER_CREATION_FIELDS_MAP
} from './SendoverForm/SendoverForm.constants';

const SEND_EMAIL_TO_HIRING_AUTHORITY = true;

export const prepareSendoverPayload = ({ formData = {} }) => {
  const sendoverFields = prepareFormToSubmit(formData, SENDOVER_CREATION_FIELDS_MAP);
  const emailFields = prepareFormToSubmit(formData, SENDOVER_CREATION_EMAIL_FIELDS_MAP);
  const automaticReminder = formData[FORM_FIELDS_MAP.AutomaticReminder.key];

  return {
    ...sendoverFields,
    sendEmailToHiringAuthority: SEND_EMAIL_TO_HIRING_AUTHORITY,
    email: emailFields,
    ...(typeof automaticReminder === 'boolean' && {
      hiringAuthorityFollowUpEnabled: automaticReminder
    })
  };
};

export const buildSendoverSubmissionData = ({
  formData = {},
  jobOrder = {},
  candidateInfo = {}
}) => {
  const { resolvedEmailBody, resolvedTagValues } = buildResolvedEmailBody({
    emailBody: formData[FORM_FIELDS_MAP.EmailBody.key],
    hiringAuthority: formData[FORM_FIELDS_MAP.HiringAuthority.key],
    candidate: formData[FORM_FIELDS_MAP.Candidate.key],
    jobOrder,
    candidateInfo
  });

  return {
    payload: prepareSendoverPayload({ formData }),
    confirmation: {
      resolvedEmailBody,
      resolvedTagValues
    }
  };
};
